<template>
    <card-seplag titulo="FAQ - Perguntas Frequentes">
        <div class="p-col-12">
            <Accordion class="accordion accordion-custom" :activeIndex="0">
                <AccordionTab v-for="(pergunta, index) in perguntas" :key=pergunta.titulo>
                    <template #header>
                        <span>{{ index + 1 + ". " + pergunta.descPerguntaFaq }}</span>
                    </template>
                    <p v-html="pergunta.descRespostaFaq"></p>
                </AccordionTab>
            </Accordion>
            <!-- The Modal -->
            <div id="myModal" class="modal">
                <span class="close">&times;</span>
                <img class="modal-content" id="img01">
                <div id="caption"></div>
            </div>
        </div>

        <card-seplag class="p-col-12">
            <p><strong>Não encontrou resposta para sua pergunta? Entre em contato pelo FALE CONOSCO na opção Ajuda, que
                    a Coordenadoria de Monitoramento de Pessoal/SEPLAG irá te atender.</strong></p>
        </card-seplag>
    </card-seplag>
</template>

<script scoped>
import CardSeplag from '@/template/CardSeplag.vue'
import { baseApiUrl } from '@/config/global'
export default {
    name: 'FAQ',
    components: { CardSeplag },
    data() {
        return {
            displayModal: false,
            perguntas: []
        }
    },
    methods: {
        async carregarDados() {
            this.$http.get(`${baseApiUrl}/faq/ativos`).then(res => {
                this.perguntas = res.data;
            });
        }
    },
    mounted() {
        this.carregarDados();
        this.$nextTick(function () {
            var imgs = document.querySelectorAll(".p-accordion-tab img")
            var modal = document.getElementById("myModal");
            var max = imgs.length;
            var i;

            for (i = 0; i < max; i++) {
                var img = imgs[i];
                var modalImg = document.getElementById("img01");
                var captionText = document.getElementById("caption");

                img.onclick = function () {
                    modal.style.display = "block";
                    modalImg.src = this.src;
                    captionText.innerHTML = this.alt;
                }

                // Get the <span> element that closes the modal
                var span = document.getElementsByClassName("close")[0];

                // When the user clicks on <span> (x), close the modal
                span.onclick = function () {
                    modal.style.display = "none";
                }
            }
        });
    }
}
</script>

<style>
.accordion .p-accordion-tab .p-accordion-header a {
    padding: 1.5rem 1rem;
    margin-bottom: 5px;

    color: #333333;
    background-color: #f4f4f4;
    color: #333333;
    font-weight: 700;
    -webkit-transition: background-color 0.2s, box-shadow 0.2s;
    transition: background-color 0.2s, box-shadow 0.2s;

}

.accordion img {
    width: 20%;
    height: 10%;
    cursor: pointer;
    margin-left: 200px
}

.alinhamentoFAQ {
    text-align: justify;
    word-wrap: break-word;
}

.accordion img:hover {
    opacity: 0.7;
}

@media(max-width: 480px) {
    .accordion img {
        margin-left: 0px;
        width: 200px;
        height: 100px;
    }
}



/* The Modal (background) */
.modal {
    display: none;
    /* Hidden by default */
    position: fixed;
    /* Stay in place */
    z-index: 999;
    /* Sit on top */
    padding-top: 100px;
    /* Location of the box */
    left: 0;
    top: 0;
    width: 100%;
    /* Full width */
    height: 100%;
    /* Full height */
    overflow: hidden;
    /* Enable scroll if needed */
    background-color: rgb(0, 0, 0);
    /* Fallback color */
    background-color: rgba(0, 0, 0, 0.9);
    /* Black w/ opacity */
}


/* Modal Content (image) */
.modal-content {
    margin: auto;
    display: block;
    width: 80%;
    max-width: 45%;
    ;
    max-height: 95%
}

/* Caption of Modal Image */
#caption {
    margin: auto;
    display: block;
    width: 80%;
    max-width: 700px;
    text-align: center;
    color: #ccc;
    padding: 10px 0;
    height: 150px;
}

/* Add Animation */
.modal-content,
#caption {
    -webkit-animation-name: zoom;
    -webkit-animation-duration: 0.6s;
    animation-name: zoom;
    animation-duration: 0.6s;
}

@-webkit-keyframes zoom {
    from {
        -webkit-transform: scale(0)
    }

    to {
        -webkit-transform: scale(1)
    }
}

@keyframes zoom {
    from {
        transform: scale(0)
    }

    to {
        transform: scale(1)
    }
}

/* The Close Button */
.close {
    position: absolute;
    top: 15px;
    right: 35px;
    color: #f1f1f1;
    font-size: 40px;
    font-weight: bold;
    transition: 0.3s;
}

.close:hover,
.close:focus {
    color: #bbb;
    text-decoration: none;
    cursor: pointer;
}

/* 100% Image Width on Smaller Screens */
@media only screen and (max-width: 700px) {
    .modal-content {
        width: 100%;
    }
}
</style>

